import { UPDATE_PUBLISHER_RECORD } from 'root/src/client/logic/agency/actionIds'

export default payload => ({
	type: UPDATE_PUBLISHER_RECORD,
	payload,
})
